<template>
  <div class="memberbox">
    <p>{{list[0].member_type}}</p>
    <div class="listbox">
      <div class="listitem"
        v-for="(item,index) in list" :key="index" 
        :class="{'activeitem': item.id==idx}"
        @click="clickitem(item,item.id)"
      >
        <p class="one-p">{{item.card_type}}</p>
        <p>赠{{Number(item.credits).toFixed(2)}}积分</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    };
  },
  props:{
    list:{type:Array},
    itemKey:{type:String},
    idx:{type:Number,default:-1}
  },
  methods: {
    clickitem(item,index){
      this.$emit('getitem', {item, itemKey: this.itemKey, index})
    },
  },
};
</script>

<style lang="less" scoped>
.memberbox{
  > p{
    margin: 12px 0;
    font-size: 14px;
  }
  .listbox{
    width: 100%;
    display: grid;
    grid-template-columns:  repeat(3, 33.3333%);
    .listitem{
      display: inline-block;
      width: 110px;
      height: 62px;
      border:1px solid #dddddd;
      color: #dddddd;
      box-sizing: border-box;
      border-radius: 5px;
      margin-bottom: 10px;
      text-align: center;
      overflow: hidden;
      &:nth-child(3n+2){
        margin: 0 auto;
      }
      &:nth-child(3n+3){
        margin-left: auto;
        margin-right: 0 ;
      }
      &:nth-last-of-type(1),&:nth-last-of-type(2),&:nth-last-of-type(3){
        margin-bottom: 0;
      }
      > p:nth-of-type(1){
        font-size: 15px;
        line-height: 24px;
        margin-top: 10px;
        font-weight: bold!important;
      }
      > p:nth-of-type(2){
        font-size: 12px;
        line-height: 17px;
      }
      
    }
    .activeitem{
      border:1px solid transparent;
      background:linear-gradient(270deg,#F41A3C 0%,#FC740C 100%);
      color:#fff;
    }
  }
}

</style>